export const university_partners_data = [
  {
    img: "/soba/desktop/university_partners_carmel.png",
    uni_name: "Mount Carmel College Autonomous",
    text: "Bengaluru",
    newsLink: "",
  },
  {
    img: "/soba/desktop/university_partners_jain.png",
    uni_name: "JAIN (Deemed-to-be) University",
    text: "Bengaluru",
    newsLink: "",
  },
  {
    img: "/soba/desktop/university_partners_krishtu.png",
    uni_name: "Kristu Jayanti College",
    text: "Bengaluru",
    newsLink: "",
  },
  {
    img: "/soba/desktop/university_partners_rajagir.png",
    uni_name: "Rajagiri College of Social Sciences",
    text: "Kochi",
    newsLink: "",
  },
];

export const in_the_news_data = [
  {
    img: "/soba/desktop/news_1.png",
    text: "Guthli Soars as 100 Universities Unite at India’s First-ever Student-led Ad Fest by Miles SOBA ",
    newsLink:
      "https://www.mid-day.com/buzz/article/guthli-soars-as-100-universities-unite-at-indias-first-ever-student-led-ad-fest-by-miles-soba-celebrating-icons-piyush-pandey-and-kv-sridhar-2622",
    uni_name: "",
  },
  {
    img: "/soba/desktop/news_2.png",
    text: "Agency M Interns Shine as Trailblazing Changemakers with Innovative Product “Safe Paws” and Acts of Kindness",
    newsLink:
      "https://businessmicro.in/business/agency-m-interns-shine-as-trailblazing-changemakers-with-innovative-product-safe-paws-and-acts-of-kindness/",
    uni_name: "",
  },
  {
    img: "/soba/desktop/news_3.png",
    text: "Miles SOBA is Transforming Business Education with Innovative Ed-Work Pedagogy",
    newsLink:
      "https://www.prnewswire.com/in/news-releases/miles-soba-is-transforming-business-education-with-innovative-ed-work-pedagogy-302290148.html?tc=eml_cleartime",
    uni_name: "",
  },
  {
    img: "/soba/desktop/news_4.png",
    text: "Agency M Interns Shine as Trailblazing Changemakers with Innovative Product “Safe Paws” and Acts of Kindness",
    newsLink:
      "https://onlinenews9.in/business/agency-m-interns-shine-as-trailblazing-changemakers-with-innovative-product-safe-paws-and-acts-of-kindness/",
    uni_name: "",
  },
];

export const soba_section_one_video_carousels = [
  {
    id: "1",
    videoId: "Jz35kBkRWSI",
    thumbnail: "/soba/soba-vide1.png",
  },
  {
    id: "2",
    videoId: "lr-tniMuqdw",
    thumbnail: "/soba/soba-video3.webp",
  },
];

export const soba_section_two_video_carousels = [
  {
    id: "1",
    videoId: "b-1awztYV0w",
    thumbnail: "https://img.youtube.com/vi/b-1awztYV0w/hqdefault.jpg",
  },
  {
    id: "2",
    videoId: "xdNXMIn8DaA",
    thumbnail: "https://img.youtube.com/vi/xdNXMIn8DaA/hqdefault.jpg",
  },
  {
    id: "3",
    videoId: "GjcSIgxno6s",
    thumbnail: "https://img.youtube.com/vi/GjcSIgxno6s/hqdefault.jpg",
  },
  {
    id: "4",
    videoId: "EbPXHMhZN8Y",
    thumbnail: "https://img.youtube.com/vi/EbPXHMhZN8Y/hqdefault.jpg",
  },
];

export const soba_section_three_video_carousels = [
  {
    id: "1",
    videoId: "FDu58LK6NJY",
    thumbnail: "https://img.youtube.com/vi/FDu58LK6NJY/hqdefault.jpg",
  },
  {
    id: "2",
    videoId: "-xBKkAUrpM0",
    thumbnail: "https://img.youtube.com/vi/-xBKkAUrpM0/hqdefault.jpg",
  },
  {
    id: "3",
    videoId: "RnXBXqYqLqw",
    thumbnail: "https://img.youtube.com/vi/RnXBXqYqLqw/hqdefault.jpg",
  },
  {
    id: "4",
    videoId: "OpgUIt_RSCk",
    thumbnail: "https://img.youtube.com/vi/OpgUIt_RSCk/hqdefault.jpg",
  },
  {
    id: "5",
    videoId: "_AeNtTS2ffA",
    thumbnail: "https://img.youtube.com/vi/_AeNtTS2ffA/hqdefault.jpg",
  },
  {
    id: "6",
    videoId: "FkfmNwJ5M9U",
    thumbnail: "https://img.youtube.com/vi/FkfmNwJ5M9U/hqdefault.jpg",
  },
  {
    id: "7",
    videoId: "jFO8zlBWhSk",
    thumbnail: "https://img.youtube.com/vi/jFO8zlBWhSk/hqdefault.jpg",
  },
  {
    id: "8",
    videoId: "2njbMq5paEc",
    thumbnail: "https://img.youtube.com/vi/2njbMq5paEc/hqdefault.jpg",
  },
];
